import React from 'react';

export default function IconBoxStyle11({
  title,
  subTitle,
  iconSrc,
  link,
}) {
  return (
    <div className="cs_iconbox cs_style_11 cs_radius_25">
      <div className="cs_iconbox_icon">
        <img src={iconSrc} alt={title} />
      </div>

      <div className="cs_iconbox_right">
        <h3 className="cs_iconbox_title cs_fs_24 mb-0">
          {title}
        </h3>

        <a
          href={link}
          className="cs_iconbox_subtitle mb-0 cs_heading_color text-decoration-none"
        >
          {subTitle}
        </a>
      </div>
    </div>
  );
}